import React, { useEffect, useState, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, Circle } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "./BcpMap.css";
import { apiGet, apiPostJSON } from '../services/api';
import { useNavigate } from "react-router-dom";

const homeIcon = L.icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/25/25694.png",
  iconSize: [32, 32],
});

const shelterIcon = L.icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/854/854878.png",
  iconSize: [30, 30],
});

const BcpHomeShelter = () => {
  const [employee, setEmployee]         = useState(null);
  const [coords, setCoords]             = useState(null);
  const [shelters, setShelters]         = useState([]);
  const [loading, setLoading]           = useState(true);
  const [savedMsg, setSavedMsg]         = useState('');
  const [selectedShelter, setSelectedShelter] = useState(null);
  const [error, setError]               = useState(null);
  const savedTimerRef                   = useRef(null);
  const navigate                        = useNavigate();

  useEffect(() => {
    let cancelled = false;
    async function fetchData() {
      try {
        const employeeData = await apiGet("/api/employee/");
        if (cancelled) return;
        setEmployee(employeeData.employee || null);

        const geoData = await apiGet("/api/bcp/geocode-employee/");
        if (cancelled) return;

        if (geoData.lat && geoData.lng) {
          setCoords([geoData.lat, geoData.lng]);
        } else {
          setError("登録住所の座標情報が見つかりません。プロファイルで住所を設定してください。");
        }
        setShelters(geoData.nearby_shelters || []);

        /* 既存保存データがあれば選択状態を復元（メッセージは出さない） */
        if (employeeData.employee_bcp && employeeData.employee_bcp.nearest_shelter) {
          setSelectedShelter(employeeData.employee_bcp.nearest_shelter);
        } else if (geoData.nearby_shelters && geoData.nearby_shelters.length > 0) {
          setSelectedShelter(geoData.nearby_shelters[0]);
        }
      } catch (err) {
        if (!cancelled) {
          console.error("BCPデータ取得エラー:", err);
          let msg = "データの取得に失敗しました。ネットワーク接続を確認してください。";
          try {
            const detail = JSON.parse(err.message);
            if (detail && detail.detail) msg = detail.detail;
          } catch (_) {}
          setError(msg);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    fetchData();
    return () => { cancelled = true; };
  }, []);

  const showSavedMsg = (msg) => {
    if (savedTimerRef.current) clearTimeout(savedTimerRef.current);
    setSavedMsg(msg);
    savedTimerRef.current = setTimeout(() => setSavedMsg(''), 3000);
  };

  const handleSave = async () => {
    if (!selectedShelter || !coords) return;
    try {
      const payload = {
        latitude:        coords[0],
        longitude:       coords[1],
        nearest_shelter_id: selectedShelter.id,
        shelter_name:    selectedShelter.name,
        shelter_address: selectedShelter.address || '',
        shelter_lat:     selectedShelter.latitude,
        shelter_lng:     selectedShelter.longitude,
      };
      await apiPostJSON("/api/employee-bcp/", payload);
      showSavedMsg(`「${selectedShelter.name}」を保存しました。`);
    } catch (e) {
      console.error("保存失敗:", e);
      alert("保存に失敗しました。ネットワーク接続を確認してください。");
    }
  };

  if (loading) return <p>読み込み中...</p>;
  if (error) return (
    <div className="bcp-page">
      <p className="error">{error}</p>
      <div className="bcp-btn-group">
        <button className="bcp-btn-back" onClick={() => navigate("/bcp")}>戻る</button>
      </div>
    </div>
  );
  if (!coords) return <p>登録住所情報が見つかりません。</p>;

  return (
    <div className="bcp-page">
      <h2>登録住所周辺の避難所</h2>

      {employee && (
        <p>
          <b>社員名:</b> {employee.name || "不明"}&nbsp;
          <b>登録住所:</b> {employee.address || "不明"}
        </p>
      )}

      <div className="bcp-map-wrap">
        <MapContainer center={coords} zoom={14} style={{ height: "100%", width: "100%" }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <Marker position={coords} icon={homeIcon}>
            <Popup>🏠 登録住所</Popup>
          </Marker>

          {/* 1km 範囲を表示（この円内の避難所をすべてマーカー表示） */}
          <Circle center={coords} radius={1000} color="blue" />

          {shelters.map((shelter) => {
            const isSelected = selectedShelter && selectedShelter.id === shelter.id;
            return (
              <Marker
                key={shelter.id ?? `${shelter.latitude}-${shelter.longitude}`}
                position={[shelter.latitude, shelter.longitude]}
                icon={shelterIcon}
                eventHandlers={{ click: () => setSelectedShelter(shelter) }}
              >
                <Popup>
                  <b>{shelter.name}</b>{isSelected && " ✔ 選択中"}<br />
                  {shelter.address}<br />
                  距離: {shelter.distance_km} km
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>{/* end bcp-map-wrap */}
      
      {selectedShelter && (
        <div className="selected-box">
          <span className="selected-info">
            選択中の避難所: <b>{selectedShelter.name}</b>
          </span>
          {/*}
          <button onClick={handleSave} className="bcp-btn-save">
            保存
          </button>
          {savedMsg && <span className="saved-message">{savedMsg}</span>}
            */}
          </div>
      )}
        
      <div className="bcp-btn-group" style={{ marginTop: 20 }}>
        <button className="bcp-btn-back" onClick={() => navigate("/bcp")}>
          戻る
        </button>
      </div>
    </div>
  );
};

export default BcpHomeShelter;
